// This icon file is generated automatically.
var PEditOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.03 10.75h.09l2.63-.47c.03 0 .06-.02.08-.04l6.62-6.63a.16.16 0 000-.22L9.85.8a.15.15 0 00-.1-.04.15.15 0 00-.11.05L3 7.42a.16.16 0 00-.04.08l-.46 2.63c-.03.17.02.34.14.47.1.1.24.15.38.15zm1.05-2.72l5.67-5.67 1.14 1.14-5.67 5.67-1.38.25.24-1.4zm8.67 4.03H1.25a.5.5 0 00-.5.5v.56c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-.56a.5.5 0 00-.5-.5z", "fill-rule": "nonzero" } }] }, "name": "p-edit", "theme": "outlined" };
export default PEditOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PEditOutlined.js
// module id = 3350
// module chunks = 0